export function header() {
  const path = location.pathname;

  const header = document.querySelector('.j-header');
  const headerBtn = document.querySelector('.j-header_btn');
  const headerLinks = document.querySelectorAll('.j-header_link');
  const bgBlackSections = document.querySelectorAll('.bg-black');

  if (!header) return;

  if (headerBtn) {
    headerBtn.addEventListener('click', () => {
      header.classList.toggle('active');
    });
  }

  // const updateHeaderColor = () => {
  //   const headerHeight = header.offsetHeight;

  //   const isInBlackSection = [...bgBlackSections].some((section) => {
  //     const rect = section.getBoundingClientRect();

  //     return rect.top <= headerHeight && rect.bottom > headerHeight;
  //   });

  //   header.classList.toggle('dark', isInBlackSection);
  // };

  // window.addEventListener('scroll', updateHeaderColor, { passive: true });
  // window.addEventListener('resize', updateHeaderColor);

  // updateHeaderColor();

  headerLinks.forEach((link) => {
    if (link.dataset.page === path) {
      link.classList.add('is-here');
    }
  });

  /**
   * SP時：リンククリックでメニューを閉じる
   */
  if (window.matchMedia('(max-width: 768px)').matches) {
      headerLinks.forEach((link) => {
          link.addEventListener('click', () => {
              if (header.classList.contains('active')) {
                  header.classList.remove('active');
              }
          });
      });
  }
}